import React, { useCallback, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Typography from '@material-ui/core/Typography';
import { FORM_FIELDS_MAP } from 'features/sendouts/components/drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';
import strings from 'strings';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';
import { REQUIRED_VALIDATION } from 'UI/utils';

import { getTimezones } from './TimezoneSelector.utils';

const STRINGS = strings.sendouts.form;

export const TimezoneSelector = ({ interviewDate = null, interviewTime = null }) => {
  const { control, errors } = useFormContext();
  const timezoneOptions = useMemo(
    () =>
      getTimezones({
        interviewDate,
        time: interviewTime
      }), // TODO: once the new api is ready, we should get the timezones from the backend instead of using a static list
    [interviewDate, interviewTime]
  );

  const handleOnChange = useCallback(([, value]) => value, []);

  return (
    <Controller
      name={FORM_FIELDS_MAP.InterviewTimezone.key}
      control={control}
      rules={REQUIRED_VALIDATION}
      defaultValue={null}
      onChange={handleOnChange}
      onChangeName="onSelect"
      valueName="selectedValue"
      as={
        <AutocompleteSelect
          error={!!errors[FORM_FIELDS_MAP.InterviewTimezone.key]}
          errorText={errors[FORM_FIELDS_MAP.InterviewTimezone.key]?.message}
          placeholder={STRINGS.labels.timezone}
          options={timezoneOptions}
          renderOption={record => (
            <Typography>
              {record.title} <br />
              <Typography variant="caption" component="span" color="textSecondary">
                ({record.offset_title})
              </Typography>
            </Typography>
          )}
        />
      }
    />
  );
};
